import { render } from "./ZenTwo.vue?vue&type=template&id=544abe24"
import script from "./ZenTwo.vue?vue&type=script&lang=js"
export * from "./ZenTwo.vue?vue&type=script&lang=js"

import "./ZenTwo.vue?vue&type=style&index=0&id=544abe24&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__